import NoteItem from "../dashboard/dashboardInbox/NoteItem";
import ExportNoteItem from "../export/ExportNoteItem";

function Row({
  isExportWindow,
  isAlreadyExported,
  row,
  refetch,
  activeTab,
}) {
  return (
    <div key={row.key} className="w-full">
      <>
        {isExportWindow ? (
          <ExportNoteItem
            exportNoteData={row}
            isAlreadyExported={isAlreadyExported}
            refetch={refetch}
            index={row.index}
            activeTab={activeTab}
          />
        ) : (
          <NoteItem
            note={row}
            dataTestIdTemplate={row?.jobTypeName}
            dataTestIdNoteTitle={`${activeTab}-${row?.title}`}
            dataTestIdUuid={`${activeTab}-${row?.uuid}`}
          />
        )}
      </>
    </div>
  );
}

export default Row;
